/**
 * Series colours, in order.
 *
 * Chart.js paints on a canvas, so these cannot be CSS variables and do not
 * follow the theme. They are the app's own blue-600 and green-600, the same
 * pair the rest of the product uses for a primary action and a success, so a
 * chart reads as part of the app rather than as its own palette.
 */
const BLUE_600 = "25, 135, 203";
const GREEN_600 = "109, 179, 16";

const series = (rgb: string) => ({
    backgroundColor: `rgba(${rgb}, 0.65)`,
    borderColor: `rgba(${rgb}, 1)`,
    pointBackgroundColor: `rgba(${rgb}, 1)`,
    borderWidth: 2,
});

export const CHART_COLOURS = [series(BLUE_600), series(GREEN_600)];
